import React from 'react';
import LoadingPlaceholder from '../../../../muiComponents/LoadingPlaceholder';
import Card from '../../../../muiComponents/Card';

const LoadingZitoneoServices = () => {
    return (
        <main className='service__container'>
            <div className='service__menu-container'>
                <LoadingPlaceholder variant='text' width={'100%'} />
                <LoadingPlaceholder variant='text' width={'100%'} />
                <LoadingPlaceholder variant='text' width={'100%'} />
                <LoadingPlaceholder variant='text' width={'100%'} />
            </div>
            <div className='flex-grow flex-column flex-center-center'>
                <div className='zitoneo-services-page__content'>
                    <LoadingPlaceholder
                        variant='text'
                        height={24}
                        width={'300px'}
                    />
                    <div className='flex-grow overflow-auto padding-right-10'>
                        <Card className='padding20'>
                            <LoadingPlaceholder
                                variant='text'
                                height={60}
                                width={'100%'}
                            />
                            <LoadingPlaceholder
                                variant='text'
                                height={60}
                                width={'100%'}
                            />
                            <LoadingPlaceholder
                                variant='text'
                                height={60}
                                width={'100%'}
                            />
                            <LoadingPlaceholder
                                variant='text'
                                height={60}
                                width={'100%'}
                            />
                        </Card>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default LoadingZitoneoServices;
